<template>
  <advanced-card
    :init-collapsed="false"
    :title="label"
    :tooltip="tooltip"
  >
    <div class="list-item">
      <div class="form-group">
        <div class="base-input">
          <div
            v-if="enableModal"
            class="open-modal-icon"
            @click="onOpenModalClick($event)"
          >
            <img src="@images/icons/edit-2.svg">
          </div>
          <textarea
            class=""
            rows="5"
            :value="value"
            @change="changeEvent($event)"
          ></textarea>
        </div>
      </div>
    </div>
  </advanced-card>
</template>

<script>
import CodeEditModal from "@/components/campaign/adtags/CodeEditModal.vue"

export default {
  name: "CustomCode",
  props: {
    label: {
      type: String,
      default: "Custom Code"
    },
    tooltip: {
      type: String,
      default: "Here you can add custom scripts/html to the adtag"
    },
    value: {
      type: String,
      default: null
    },
    enableModal: {
      type: Boolean,
      default: true
    }
  },
  emits: ["update"],
  methods: {
    updateCode (code) {
      this.$emit("update", code)
    },
    changeEvent (event) {
      this.updateCode(event.currentTarget.value)
    },
    onOpenModalClick () {
      this.$modal.show(CodeEditModal, {
        value: this.value,
        success: (code) => {
          this.updateCode(code)
        }
      })
    }
  }
}
</script>

<style scoped>

.open-modal-icon {
  position: absolute;
  top: auto;
  bottom: 10px;
  right: 5px;
}

.base-input {
  margin-top: 10px;
}

textarea {
  width: 100%;
  padding: 10px;
  min-height: 50px;
  max-height: 200px;
  background: #181a1d;
  color: $white;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.26px;
  border-radius: 8px;

  border: solid 2px transparent;
  overflow: auto;

  &:focus,
  &:active {
    outline: none !important;
  }

  resize: none;
}
</style>
